import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import VenueSelector from 'components/VenueSelector';

import { RightButtonContext } from './Contexts';

const Control = ({ className, rightButton, venueSelector, children, ...rest }) => {
  if (rightButton && children) {
    return (
      <RightButtonContext.Consumer>
        {ref => ref && ref.current && ReactDOM.createPortal(children, ref.current)}
      </RightButtonContext.Consumer>
    );
  }

  if (venueSelector) {
    children = <VenueSelector {...rest} />;
  }

  return <div className={className}>{children}</div>;
};

Control.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  rightButton: PropTypes.bool,
  venueSelector: PropTypes.bool,
};

export default Control;
